import React, {useState} from 'react'
import PropTypes from "prop-types"
import {
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Checkbox,
  FormGroup,
  TextField
} from '@material-ui/core';
import { AboutRegistryJss } from '../AboutRegistry/styleJss'
import {
  OTHER_MARKETS_SECTION_NAME,
  REAL_PLAZA_GO_OPTION_NAME,
  MERCADO_LIBRE_OPTION_NAME,
  JUNTOZ_OPTION_NAME,
  FALABELLA_OPTION_NAME,
  SHOPSTAR_OPTION_NAME,
  LINIO_OPTION_NAME,
  PLAZAVEA_OPTION_NAME,
  OTHER_OPTION_MAX_LENGTH,
  OTHER_OPTION_NAME,
} from "../../../../constants"

const FIELD_NAME = 'other_markets_added'
const FIELD_NAME_LIST = 'other_markets'
const options = {
  [MERCADO_LIBRE_OPTION_NAME]: 'Mercado Libre',
  [JUNTOZ_OPTION_NAME]: 'Juntoz',
  [FALABELLA_OPTION_NAME]: 'Falabella',
  [SHOPSTAR_OPTION_NAME]: 'Shopstar',
  [LINIO_OPTION_NAME]: 'Linio',
  [REAL_PLAZA_GO_OPTION_NAME]: 'Real Plaza GO',
  [PLAZAVEA_OPTION_NAME]: 'PlazaVea',
  [OTHER_OPTION_NAME]: 'Otro (¿Cuál?)',
};

const MarketsForm = ({stateProps}) => {
  const [checksStatus, setChecksStatus] = useState({
    [MERCADO_LIBRE_OPTION_NAME]: false,
    [JUNTOZ_OPTION_NAME]: false,
    [FALABELLA_OPTION_NAME]: false,
    [SHOPSTAR_OPTION_NAME]: false,
    [LINIO_OPTION_NAME]: false,
    [REAL_PLAZA_GO_OPTION_NAME]: false,
    [PLAZAVEA_OPTION_NAME]: false,
    [OTHER_OPTION_NAME]: false,
  });
  const classes = AboutRegistryJss();
  const handleCheckboxButtonChange = (event) => {
    const selectedOptionValue = event.target.value;
    const selectedOptionName = event.target.name;
    const newChecksStatus = {...checksStatus};
    newChecksStatus[selectedOptionName] = !checksStatus[selectedOptionName];
    stateProps.handleSetState(selectedOptionName, OTHER_MARKETS_SECTION_NAME)(newChecksStatus[selectedOptionName])
    setChecksStatus(newChecksStatus);
    if (!newChecksStatus[OTHER_OPTION_NAME]) {
      let actualList = stateProps.state[OTHER_MARKETS_SECTION_NAME]
      let newList
      if(newChecksStatus[selectedOptionName]){
        /** ADD STRING **/
        newList = !actualList.includes(selectedOptionValue) ? [actualList,selectedOptionValue].join(',') : actualList
      }else{
        /** REMOVE STRING **/
        newList = actualList.includes(selectedOptionValue) ? ((actualList.replace(selectedOptionValue+',','')).replace(selectedOptionValue,'')).replace(/,\s*$/, "") : actualList
      }
      stateProps.handleSetState(FIELD_NAME_LIST, OTHER_MARKETS_SECTION_NAME)(newList.replace(/^,/, ''))
    } else {
      stateProps.handleSetState(FIELD_NAME, OTHER_MARKETS_SECTION_NAME)("");
      handleClickAway();
    }
  };

  const handleInputChange = (event) => {
    stateProps.handleSetState(FIELD_NAME, OTHER_MARKETS_SECTION_NAME)(event.target.value);
  }

  const handleClickAway = (event) => {
    if (stateProps.state[FIELD_NAME] === '') {
      stateProps.onRestoreErrors(OTHER_MARKETS_SECTION_NAME, FIELD_NAME);
    }
  };

  return (
    <Grid
      container
      item
      direction="row"
      className={classes.root}
    >
      <Grid item
          container
          direction="row" className={classes.formGrid}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend" className={classes.legend}><b>¿Estás en otros Marketplace?</b></FormLabel>
          <FormGroup className={classes.gridGroup}>
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[MERCADO_LIBRE_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={MERCADO_LIBRE_OPTION_NAME}
                  value={options[MERCADO_LIBRE_OPTION_NAME]}
                />
              }
              label={options[MERCADO_LIBRE_OPTION_NAME]}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[LINIO_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={LINIO_OPTION_NAME}
                  value={options[LINIO_OPTION_NAME]}
                />
              }
              label={options[LINIO_OPTION_NAME]}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[JUNTOZ_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={JUNTOZ_OPTION_NAME}
                  value={options[JUNTOZ_OPTION_NAME]}
                />
              }
              label={options[JUNTOZ_OPTION_NAME]}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[REAL_PLAZA_GO_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={REAL_PLAZA_GO_OPTION_NAME}
                  value={options[REAL_PLAZA_GO_OPTION_NAME]}
                />
              }
              label={options[REAL_PLAZA_GO_OPTION_NAME]}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[FALABELLA_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={FALABELLA_OPTION_NAME}
                  value={options[FALABELLA_OPTION_NAME]}
                />
              }
              label={options[FALABELLA_OPTION_NAME]}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[PLAZAVEA_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={PLAZAVEA_OPTION_NAME}
                  value={options[PLAZAVEA_OPTION_NAME]}
                />
              }
              label={options[PLAZAVEA_OPTION_NAME]}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[SHOPSTAR_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={SHOPSTAR_OPTION_NAME}
                  value={options[SHOPSTAR_OPTION_NAME]}
                />
              }
              label={options[SHOPSTAR_OPTION_NAME]}
            />       
            <FormControlLabel
              className={classes.label}
              control={
                <Checkbox
                  color="primary"
                  checked={stateProps.state[OTHER_OPTION_NAME]}
                  onChange={handleCheckboxButtonChange}
                  name={OTHER_OPTION_NAME}
                  value={options[OTHER_OPTION_NAME]}
                />
              }
              label={options[OTHER_OPTION_NAME]}
            />
          </FormGroup>
          { stateProps.state[OTHER_OPTION_NAME] &&
            <ClickAwayListener onClickAway={handleClickAway}>
              <TextField
                fullWidth
                id="other-registry"
                placeholder="Escribe otra opción"
                variant="outlined"
                size="small"
                onChange={handleInputChange}
                error={stateProps.errors.other_markets_added !== undefined && stateProps.errors.other_markets_added !== ''}
                helperText={stateProps.errors.other_markets_added}
                inputProps={{
                  maxLength: OTHER_OPTION_MAX_LENGTH
                }}
              />
            </ClickAwayListener>
          }
        </FormControl>
      </Grid>
    </Grid>
  )
}

MarketsForm.propTypes = {
  stateProps: PropTypes.exact({
    state: PropTypes.exact({
      [MERCADO_LIBRE_OPTION_NAME]: PropTypes.bool,
      [JUNTOZ_OPTION_NAME]: PropTypes.bool,
      [FALABELLA_OPTION_NAME]: PropTypes.bool,
      [SHOPSTAR_OPTION_NAME]: PropTypes.bool,
      [LINIO_OPTION_NAME]: PropTypes.bool,
      [REAL_PLAZA_GO_OPTION_NAME]: PropTypes.bool,
      [PLAZAVEA_OPTION_NAME]: PropTypes.bool,
      [OTHER_OPTION_NAME]: PropTypes.bool,
      other_markets: PropTypes.string,
      other_markets_added: PropTypes.string,
    }),
    country: PropTypes.string.isRequired,
    setState: PropTypes.func.isRequired,
    handleSetState: PropTypes.func.isRequired,
    errors: PropTypes.exact({
      other_markets: PropTypes.string,
      other_markets_added: PropTypes.string,
    }),
    onRestoreErrors: PropTypes.func,
  }),
}

export default MarketsForm
